// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"570":"ee9bd7034873cab2","655":"c3c00f8cb81cd983"}[chunkId] + ".js";
};